import type { ReportSummary } from '@testflow/shared';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ExitCriteriaList } from '../exit-criteria-list.js';
import { GoNoGo } from '../go-no-go.js';

export function ExitCriteriaCard({
  exitCriteria,
}: {
  exitCriteria: ReportSummary['exitCriteria'];
}) {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? 'de';

  return (
    <section className="rounded-card border border-[var(--border)] bg-bg-surface p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-sm font-bold text-text-primary">{t('reporting.rep5')}</h2>
        <div className="flex items-center gap-3">
          <GoNoGo
            value={exitCriteria.goNoGo}
            goLabel={t('reporting.go')}
            noGoLabel={t('reporting.noGo')}
            notConfiguredLabel={t('reporting.goNotConfigured')}
          />
          <span className="font-mono text-[10.5px] text-text-muted">REP-5</span>
        </div>
      </div>
      <p className="mb-3 text-[10px] text-text-muted">{t('reporting.scopePlan')}</p>
      <ExitCriteriaList data={exitCriteria} lang={lang} />
      {/* #86: ohne Exit-Kriterien ist "kein Go" nicht selbsterklärend — Hinweis + direkter
          Link zur Admin-Konfiguration, statt den Nutzer vor einer leeren Liste raten zu lassen. */}
      {exitCriteria.goNoGo === 'not_configured' ? (
        <p className="text-sm text-text-muted">
          {t('reporting.exitEmpty')}{' '}
          <Link to="/admin/exit-criteria" className="text-brand-accent hover:underline">
            {t('dashboard.status.configureExit')}
          </Link>
        </p>
      ) : null}
    </section>
  );
}
